const TransferOrders = {
  el: {
    root: null as HTMLElement | null,
    triggers: [] as HTMLButtonElement[],
  },
  scrollTimeout: null as number | null,
  init() {
    this.setElements()

    if (this.el.root) {
      this.handleAccordion()
      this.handleFilterChange()
    }
  },
  setElements() {
    this.el.root = document.querySelector<HTMLElement>('.transfer-orders, .tvg-transfer-orders')
    this.el.triggers = Array.from(document.querySelectorAll<HTMLButtonElement>('button.transferorder-item__trigger, button.transferorder-item__button, button.tvg-transferorder-item__button'))
  },
  handleAccordion() {
    this.el.triggers.forEach((trigger) => {
      const row = trigger.closest<HTMLElement>('.transferorder-item__trigger, .tvg-transferorder-item__trigger')
      row?.addEventListener('click', () => {
        const item = trigger.closest<HTMLElement>('.transferorder-item, .tvg-transferorder-item')
        const isOpen = item?.classList.contains('open')

        this.closeItems()

        if (item && !isOpen) {
          item.classList.add('open')
          trigger.setAttribute('aria-expanded', 'true')
          this.scrollToTrigger(trigger)
        }
      })
    })
  },
  scrollToTrigger(trigger: HTMLButtonElement) {
    if (this.scrollTimeout) {
      window.clearTimeout(this.scrollTimeout)
    }

    this.scrollTimeout = window.setTimeout(() => {
      trigger.closest<HTMLElement>('.transferorder-item__trigger, .tvg-transferorder-item__trigger')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      this.scrollTimeout = null
    }, 250)
  },
  handleFilterChange() {
    document.addEventListener('filter:change', () => {
      this.closeItems()
    })
  },
  closeItems() {
    this.el.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false')
      trigger.closest<HTMLElement>('.transferorder-item, .tvg-transferorder-item')?.classList.remove('open')
    })
  },
}

export default TransferOrders
